export default __webpack_public_path__ + "static/media/jollof0.d5778955.jpg";